module.exports = __webpack_public_path__ + "img/icon_bg6.8f77855c.png";